<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;margin-top: 1rem;" class="fontMS700 font-40 colorPrincipal">
            MODA DEL SIGLO XIX<br>
            <span class="fontMS300 font-24" >
                LIMA A TRAVÉS DE SUS VESTIMENTAS<br>
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio31/moda-siglo">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio31/moda-siglo">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio31/moda-siglo">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio31/MODA-000.png">
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-justify font-24">
                    A LO LARGO DEL TIEMPO CÓMO Y CON QUÉ NOS VESTIMOS HA SIGNIFICADO 
                    UN ELEMENTO IMPORTANTE PARA DESCRIBIR Y CONOCER LAS COSTUMBRES, 
                    CRITERIOS Y GUSTOS DE UNA SOCIEDAD. LAS FORMAS DE VESTIR NOS REPRESENTAN 
                    Y TRANSMITEN PARTE DE NUESTRA IDENTIDAD. LA VESTIMENTA HA ACOMPAÑADO AL 
                    SER HUMANO A LO LARGO DE SU EXISTENCIA. 
                </p>
                
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio31/MODA-TRAMA-000.png" width="100%">
            </div>
            <div class="col-sm-1"></div>

            <div class="col-sm-2"></div>
            <div class="col-sm-8 mt4 mb4">
                <p class="fontMS500Italic text-center font-24 mt-3 text-gris">
                    Las prendas que usamos no son un elemento aislado sino que acompañan 
                    o son producto de una época y su desarrollo.
                </p>
            </div>
            <div class="col-sm-2"></div>

            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio31/MODA-TRAMA-001.png" 
                    width="100%">
            </div>
        </div>
    </div>
</div>

<a href="https://hdl.handle.net/20.500.14428/9826" target="_blank" style="color: black;">
<div class="fondoImagen">
    <div class="container">

    </div>
</div>
</a>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3 mt4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            EL DAGUERROTIPO<br>
                            Y LAS PRIMERAS <br>
                            FOTOGRAFÍAS DE LIMA<br>
                        </p>
                    </div>
                    <div class="col-sm-3 mt4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                class="fontMS700 text-center colorPrincipal font-40">
                
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                </div>

                <div class="row mt4">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5">
                        <a  style="color: black;">
                            <!-- <a [routerLink]="['/visor/FOT-54893']" target="_blank" style="color: black;"> -->
                            <img width="100%" class="img3_extremo mt-3" 
                            src="/assets/images/micrositio/micrositio31/MODA-001.png">
                        </a>
                    </div>
                    <div class="col-sm-5">
                        <a href="http://hdl.handle.net/20.500.14428/79587" target="_blank" style="color: black;">
                            <img width="100%" class="img3_extremo mt-3" 
                            src="/assets/images/micrositio/micrositio31/MODA-002.png">
                        </a>
                    </div>
                    <div class="col-sm-1"></div>

                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="fontMS300 text-gris text-justify font-24">
                            <br>
                            En 1842 el daguerrotipo, uno de los primeros sistemas para obtener fotos, 
                            llega a Lima y con él nacen los primeros estudios de fotografía. 
                            Hasta estos lugares llegaban los limeños, en solitario o con sus 
                            familias para llevar a cabo lo que hoy conocemos como una sesión de fotos. 
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoVerde">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;margin-top:3%" class="fontMS700 text-white font-35">
                            ¿POR QUÉ ERA IMPORTANTE<br>
                            TOMARSE UNA FOTO?
                        </p>
                    </div>
                    <div class="col-sm-6 ">
                        <img class="LineSubsec_Izq" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-001.png">
                    </div>
                </div>
                <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS100 text-white font-38">

                </p>
                <div class="row">
                    <div class="col-sm-11">
                        <div class="row">
                            <div class="col-sm-6 mt-5" >
                                <div style="background-color: #fff;" >
                                    <a href="https://hdl.handle.net/20.500.14428/38707" target="_blank" style="color: black;">
                                        <img class="img5"
                                            src="/assets/images/micrositio/micrositio31/MODA-003.png">
                                    </a>
                                    <p class="fontMS100Italic text-justify font-20 pl-5">
                                        Los sombreros aportan elegancia, complementando el atuendo. 
                                        Sobrios en el caso masculino. Con accesorios y 
                                        decoraciones en el caso femenino.
                                    </p>
                                </div>
                            </div>
                            
                            <div class="col-sm-6">
                                <p class="font-22 fontMS300 text-white text-justify">
                                    <br><br>
                                    Una fotografía es una forma de dejar huella en el tiempo. 
                                    A través de ellas podemos conocer parte de la historia.<br>
                                    La postura, las prendas y accesorios con las que posaban 
                                    los retratados, evidenciaban su gran posición social y económica.
                                    <br><br>
                                </p>
                                <div style="background-color: #fff;" >
                                    <img class="img5"
                                    src="/assets/images/micrositio/micrositio31/MODA-004.png">
                                    <p class="fontMS100Italic text-justify font-20 pl-5">
                                        Los accesorios como guantes, anillo y bastón, 
                                        reflejaban el estatus del retratado.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3 mt4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LA RESISTENCIA DE LA<br>
                            TAPADA LIMEÑA<br>
                        </p>
                    </div>
                    <div class="col-sm-3 mt4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                class="fontMS700 text-center colorPrincipal font-40">
                
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                </div>

                <div class="row mt4">
                    
                    <div class="col-sm-12">
                        <p class="fontMS300 text-gris text-justify font-24">
                            <br>
                            LA TAPADA ES LA VESTIMENTA QUE LAS MUJERES UTILIZARON DESDE EL VIRREINATO Y DURANTE LOS INICIOS DEL S.XIX. 
                            EL ATUENDO, AL CUBRIR LA MAYOR PARTE DEL CUERPO Y ROSTRO, 
                            PERMITÍA A LAS MUJERES MANTENERSE EN EL ANONIMATO Y ACTUAR EN ESPACIOS PÚBLICOS Y POLÍTICOS QUE ERAN EXCLUSIVOS A LOS HOMBRES.
 
                            <br><br>
                        </p>
                    </div>
                    
                </div>

                <div class="row mt3">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-8">
                        <a href="https://hdl.handle.net/20.500.14428/12148"
                        target="_blank" style="color: black;">
                            <img width="100%" 
                            src="/assets/images/micrositio/micrositio31/MODA-005.png">
                        </a>
                        <p class="fontMS300Italic text-gris text-center font-20 ">
                            <br>
                            Tapada Limeña <br>
                            Dos mujeres posan vistiendo la saya 
                            y el manto. Dejando al descubierto los ojos.
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center text-white font-40">
                            DETALLES
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center colorPrincipal font-40">
                    
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                </div>

                <div class="row mt5">
                    <div class="col-sm-12 text-center">
                        <div class="libro">
                            <img width="100%" class="mt-3" 
                                src="/assets/images/micrositio/micrositio31/MODA-012.png">
                        </div>
                    </div>
                    <div class="col-sm-12 text-center">
                        <div class="libro">
                            <img width="100%" class=" mt-3" 
                                src="/assets/images/micrositio/micrositio31/MODA-013.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3 ">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 ">
                            MOMENTOS DE CAMBIO:<br>
                            UNA NUEVA FORMA DE<br>
                            VESTIR LLEGA DESDE<br>
                            EUROPA<br>
                        </p>
                    </div>
                    <div class="col-sm-3 ">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                class="fontMS700 text-center colorPrincipal font-40">
                
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                </div>

                <div class="row mt4">
                    
                    <div class="col-sm-12">
                        <p class="fontMS500 text-gris text-justify font-24">
                            <br>
                            EL COMERCIO POR MAR CON EUROPA PROPICIÓ LA LLEGADA DE PRENDAS MUY FINAS 
                            Y DE ALTO COSTO YA QUE ESTABAN CONFECCIONADAS CON TELAS DE ALTA CALIDAD 
                            E INCORPORABAN ELEMENTOS DECORATIVOS COMO BROCADOS QUE APORTABAN  MAJESTUOSIDAD 
                            Y ELEGANCIA.
                            <br><br>
                        </p>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center text-white font-40">
                            DETALLES
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center text-white font-40">
                    
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                </div>
                <p class=" fontMS300 text-white text-center font-24">
                    <br><br>
                    Elementos decorativos que se incorporan a los trajes compuestos principalmente 
                    por patrones bordados, brocados y flores.
                </p>
                <div class="row ">
                    <div class="col-sm-5 mt-3">
                        <!--<a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/imagen/fotos/04A1006.jpg"
                        target="_blank" style="color: black;">-->
                        <a href="https://hdl.handle.net/20.500.14428/35349" target="_blank" style="color: black;">
                            <img  width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-006.png">
                        </a>
                    </div>
                    <div class="col-sm-7 mt-3 text-center">
                        <img  width="90%"
                        src="\assets\images\micrositio\micrositio31\MODA-007.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio31/MODA-TRAMA-000.png" width="100%">
            </div>
            <div class="col-sm-1"></div>

            <div class="col-sm-2"></div>
            <div class="col-sm-8 mt4 mb4">
                <p class="fontMS500Italic text-center font-24 mt-3 text-gris">
                    A estas prendas solo accedían las familias más 
                    acomodadas de Lima.
                </p>
            </div>
            <div class="col-sm-2"></div>

            <div class="col-sm-1"></div>
            <div class="col-sm-11">
                <img src="/assets/images/micrositio/micrositio31/MODA-TRAMA-001.png" 
                    width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3 ">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 ">
                            LA REVOLUCIÓN<br>
                            INDUSTRIAL, EL AUGE DE LA<br>
                            MODA Y LOS CAMBIOS EN<br>
                            LIMA<br>
                        </p>
                    </div>
                    <div class="col-sm-3 ">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                class="fontMS700 text-center colorPrincipal font-40">
                
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                </div>

                <div class="row mt4">
                    
                    <div class="col-sm-6">
                        <p class="fontMS100 text-gris text-justify font-24 mt-5">
                            La revolución industrial, que se dio durante la segunda mitad del siglo, 
                            incentivó el desarrollo y crecimiento de la industria textil.<br><br>
                            En Lima, se abrieron casas de moda, donde se confeccionaban prendas de vestir 
                            y bajo el liderazgo de modistas francesas. <br><br>
                            Lima empezó a producir sus propias prendas de vestir.

                            <br>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS300 text-gris text-justify font-24">
                            <br>
                            <!--<a href="https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/imagen/fotos/02E1416.jpg"
                                target="_blank" style="color: black;">-->
                            <a href="https://hdl.handle.net/20.500.14428/35056" target="_blank" style="color: black;">
                                <img  width="100%"
                                src="\assets\images\micrositio\micrositio31\MODA-008.png">
                            </a>
                            <br><br>
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoVerde">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center text-white font-40">
                            UN TRAJE PARA CADA
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center text-white font-40">
                    OCASIÓN
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                </div>
                <p class=" fontMS300 text-white text-center font-24 mb-3">
                    <br><br>
                    LAS ACTIVIDADES COTIDIANAS Y REUNIONES SOCIALES ERAN PARTE IMPORTANTE DE LA VIDA 
                    DE LOS LIMEÑOS. POR ELLO, UN TRAJE EXCLUSIVO Y ADECUADO DEBÍA ACOMPAÑAR CADA OCASIÓN. 
                    
                </p>
                <div class="row " style="background-color: #fff;">
                    
                    <div class="col-sm-6 mt-3 mb-3">
                        <a href="https://hdl.handle.net/20.500.14428/35155" target="_blank" style="color: black;">
                            <img  width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-014.png">
                        </a>
                    </div>
                    <div class="col-sm-6 mt-3  mb-3">
                        <a href="https://hdl.handle.net/20.500.14428/35634" target="_blank" style="color: black;">                        
                            <img  width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-015.png">
                        </a>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-8">
                        <p class=" fontMS100 text-white text-center font-20">
                            <br>
                            Actividades como ir a la iglesia, salir de paseo, recibir visitas 
                            tomar el té, tenían su propio atuendo.
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                </div>
                    
            </div>
        </div>
    </div>
</div>

<a href="https://hdl.handle.net/20.500.14428/35201" target="_blank" style="color: black;">
    <div class="fondoImagen2">
        <div class="container">
    
        </div>
    </div>
</a>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3 ">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-003.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center font-40 ">
                            EL ROL DE LOS HOMBRES<br>
                            Y MUJERES REFLEJADO<br>
                            EN SU VESTIR.<br>
                            
                        </p>
                    </div>
                    <div class="col-sm-3 ">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-003.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                class="fontMS700 text-center colorPrincipal font-40">
                
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio31\MODA-LINEA-003.png">
                </div>

                <div class="row mt4">
                    
                    <div class="col-sm-12">
                        <p class="fontMS300 text-gris text-justify font-24">
                            <br>
                            LOS TRAJES FEMENINOS REFLEJAN EL ESTATUS DE LAS FAMILIAS Y LAS VIRTUDES 
                            DE LAS MUJERES RESALTANDO EL ROL DE CUIDADO DE LA FAMILIA QUE ASUMIERON 
                            EN LA ÉPOCA.
                            <br><br>
                        </p>
                        <p class="fontMS100 text-gris text-justify font-24">
                            <br>
                            Se añadieron encajes, cintas y otros elementos a los vestidos. Los cuellos 
                            se volvieron altos cubriendo el pecho y cuello. Las mangas crecieron volviéndose 
                            anchas en el brazo y pegadas en el antebrazo.
                            <br><br>
                        </p>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12 ">
                <img width="100%"  
                src="/assets/images/micrositio/micrositio31/MODA-016.png">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-5">
                        <div style="background-color: #84d576;" >
                            <a href="https://hdl.handle.net/20.500.14428/13002" target="_blank" style="color: black;">
                            <img class="img5"
                            src="/assets/images/micrositio/micrositio31/MODA-010.png">
                            </a>
                            <p class="fontMS100Italic text-justify text-white font-20 pl-5">
                                Uso del corset como parte del atuendo femenino.
                            </p>
                        </div>     
                    </div>
                    <div class="col-sm-5">
                        <div style="background-color: #84d576;" >
                            <img class="img5"
                            src="/assets/images/micrositio/micrositio31/MODA-011.png">
                            <p class="fontMS100Italic text-justify text-white font-16 pl-5">
                                Detalle del uso del corset, 
                                con aplicaciones de bordado, 
                                que marca la cintura y estiliza la figura femenina
                            </p>
                        </div>     
                    </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center text-white font-40">
                            LA VESTIMENTA PARA<br>
                            EXPRESAR EL SENTIR<br>
                            NACIONAL.<br>
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center text-white font-40">
                    
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                </div>
                <p class=" fontMS300 text-white text-justify font-24">
                    <br><br>
                    LA GUERRA CON CHILE SE DESATÓ A FINALES DEL SIGLO, Y SIGNIFICÓ PARA LA 
                    SOCIEDAD PERUANA UN TIEMPO DE DOLOR. LA MODA Y/O EL VESTIR SE CONVIRTIÓ 
                    EN UN ELEMENTO QUE ACOMPAÑABA Y REFLEJABA LAS EMOCIONES EXPERIMENTADAS.
                    EL COLOR NEGRO, UTILIZADO PARA EXPRESAR EL LUTO, FUE PREDOMINANTE EN LOS 
                    TRAJES Y VESTIDOS DE LOS LIMEÑOS.

                </p>
                <div class="row ">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <a href="https://hdl.handle.net/20.500.14428/39634" target="_blank" style="color: black;">     
                            <img  width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-017.png">
                        </a>

                        <p class=" fontMS100Italic text-white text-justify font-18">
                            <br><br>
                            <span class=" fontMS500Italic">Las novias de negro<br></span>
                            Las bodas se convirtieron en un espacio para mostrar el duelo nacional. Las 
                            novias habían perdido a sus padres, hermanos o novios y sus trajes de boda 
                            se convirtieron en un medio para manifestar su tristeza y desolación ante 
                            las muertes, pasando del tradicional color blanco al negro.
        
                        </p>
                    </div>
                    
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoVerde">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center text-white font-40">
                            CONTRASTE DE IMÁGENES
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                    class="fontMS700 text-center text-white font-40">
                    
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio31\MODA-LINEA-002.png">
                </div>
                <p class=" fontMS300 text-white text-center font-24 mb-3">
                    <br><br>
                    FOTOGRAFÍA QUE REGISTRA EL TRADICIONAL TRAJE DE BODA BLANCO (PÁG. 90 / 01C0708)
                    FOTOGRAFÍA QUE MUESTRA A LA PAREJA DE LA BODA DONDE LA NOVIA APARECE CON TRAJE NEGRO Y VELO BLANCO (PÁG. 93 / 04F3603)

                    
                </p>
                <div class="row " style="background-color: #fff;">
                    
                    <div class="col-sm-6 mt-3 mb-3">
                        <a href="https://hdl.handle.net/20.500.14428/137" target="_blank" style="color: black;">
                            <img  width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-018.png">
                        </a>
                    </div>
                    <div class="col-sm-6 mt-3  mb-3">
                        <a href="https://hdl.handle.net/20.500.14428/29931" target="_blank" style="color: black;">                        
                            <img  width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-019.png">
                        </a>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-sm-2"></div>
                    <div class="col-sm-8">
                        <p class=" fontMS100 text-white text-center font-20">
                            <br>
                            Actividades como ir a la iglesia, salir de paseo, recibir visitas 
                            y tomar el té, tenían su propio atuendo.
                        </p>
                    </div>
                    <div class="col-sm-2"></div>
                </div>
                    
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3 ">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 130%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40 ">
                            HACIA UN NUEVO SIGLO
                            
                        </p>
                    </div>
                    <div class="col-sm-3 ">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                    </div>
                </div>
                <p style="line-height: 100%;margin-top: 0%;margin-bottom: 0%;"
                class="fontMS700 text-center colorPrincipal font-40">
                
                </p>
                <div class="c100">
                    <img class="lineCel" width="100%"
                        src="\assets\images\micrositio\micrositio31\MODA-LINEA-000.png">
                </div>

                <div class="row mt4">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="fontMS300 text-gris text-justify font-24">
                            <br>
                            LA TRANSICIÓN HACIA EL S.XX SIGNIFICÓ UN CAMBIO MUY LENTO EN LA MODA. 
                            LA VESTIMENTA FEMENINA VARIÓ DEJANDO ATRÁS EL CORSÉ Y LOS TRAJES QUE 
                            CUBRÍAN CASI TODO SU CUERPO PARA DAR LUGAR AL USO DE PRENDAS MÁS 
                            CORTAS, QUE LES PERMITIERAN MAYOR LIBERTAD.
                            <br><br>
                        </p>
                        <p class="fontMS100 text-gris text-justify font-24">
                            <br>
                            La moda del S.XIX en Lima estuvo en constante cambio. Influenciada 
                            principalmente por el intercambio con Europa, permitió a la clase 
                            alta limeña reflejar su estatus y poder, y dejar huella de este 
                            a través de la fotografía.
                            <br><br>
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<hr/>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                    <div class="col-sm-4">
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec2" width="100%"
                            src="\assets\images\micrositio\micrositio12\ET02-MS05_GRE_LINEA1-400.png">
                    </div>
                </div>
            </div>

            <div class="col-sm-6 mt5">
                <p class="font-24 ">
                    <span class="fontMS500Italic">BNP. (2021). </span>
                    <span class="fontMS100Italic text-gris">
                        Moda del siglo XIX. Biblioteca Nacional del Perú. <br>
                    </span>
                </p>
                <p class="font-24">
                    <br>
                    <span class="fontMS500Italic">TVPerú. (2022, 18 abril). 
                    </span>
                    <span class="fontMS100Italic text-gris">
                        Sucedió en el 
                        Perú: Moda en el siglo XIX 
                        (17/04/2022) | TVPerú [Vídeo]. 
                        YouTube.<br>
                    </span>
                    <a href="https://www.youtube.com/watch?v=GGD_SDF0AUU" target="_blank"
                        style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
            </div>
            <div class="col-sm-6 mt5">
                <p class="font-24 ">
                    <span class="fontMS500">Escribano, P </span>
                    <span class="fontMS100Italic text-gris">
                        Las novias de blanco y 
                        negro en la Lima del siglo XIX: ¿luto o 
                        moda? (22/04/2019). La República.  <br>                   
                    </span>
                    <a href="https://larepublica.pe/tendencias/316226-las-novias-de-blanco-y-negro-en-la-lima-del-siglo-xix-luto-o-moda/"
                        target="_blank" style="color: black;">
                        <span class="fas fa-share-square text-gris"></span>
                    </a>
                </p>
            </div>
        </div>
    </div>
</div>
<!-- Footer -->